/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-recently-viewed': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M12.869 13.75l-3.494-3.494V4.375h1.25v5.363l3.125 3.13-.881.882zM10 1.25a8.71 8.71 0 00-6.25 2.644V1.25H2.5v5h5V5H4.425A7.5 7.5 0 112.5 10H1.25A8.75 8.75 0 1010 1.25z"/>'
  }
})
